import { LatLng } from "../models/common/lat-lng.model";


export class Company {

    id: number;
    placeId: string | null;
    name: string;
    location?: LatLng;
    phoneNumber: string | null;
    crNumber: number;
    taxRegNumber: string | null;
    logo: string | null;
    poBox: number | null;
    websiteURL: string | null;
    address: string;
    countryId: number;
    emailAddress: string | null;
    defaultContactId: number | null;
    transportationAgencyId: number | null;
    freightForwarderId: number | null;
    enableEnterpriseFeatures?: boolean;

}
